import Utils from '@/common/utils/utils';
import { TextField, Tooltip } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { getVisibleWidth } from '../../handler/HelpDeskTicketListHandler';
import {
    onBeforeDragStartHandler,
    onBlurViewName,
    onChangeViewSelectedHelpdeskList,
    onDoubleClickViewHelpdeskList,
    onDragViewEnd,
    onEnterViewName
} from '../../handler/HelpDeskViewHandler';
import './ViewHelpDeskList.css';
import { SettingView } from './SettingView';
import Constant from '@/common/constant/Constant';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import React, { useState } from 'react';

export default function ViewHelpDeskList(props) {
    const {
        tabs,
        viewSelected,
        setViewSelected,
        isCustomer,
        viewStructure,
        setViewStructure,
        isProjectManager,
        listView,
        setListView,
        setTriggerSearch,
        inputViewNameRef
    } = props;
    const element = document.querySelector('#container');
    const nodeListView = document.querySelectorAll('.item-helpdesk');
    const [clickTimeout, setClickTimeout] = useState(null);

    let timeoutEvent;
    const onWheel = event => {
        element.scrollLeft +=
            event.deltaY > 0 ? Constant.SCROLL_LEFT_CHANGE : Constant.SCROLL_LEFT_CHANGE * -1;
        event.stopPropagation();
        let containerRect = element.getBoundingClientRect();

        let posElem = [];
        for (let i = 0; i < nodeListView.length; i++) {
            let id = tabs[i].id;
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(nodeListView[i]);
            posElem.push({ id: id, pos: visiblePageWidth });
        }

        // trigger wheel end
        if (timeoutEvent) clearTimeout(timeoutEvent);
        timeoutEvent = setTimeout(() => {
            for (let i = 0; i < posElem.length; i++) {
                let item = posElem[i];
                if (item.pos.left + item.pos.width >= item.pos.width * Constant.LIST_VIEW_TAB) {
                    element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
                    break;
                }
            }
        }, Constant.TRIGGER_TIMEOUT_WHEEL_END);
    };

    const onTouchEnd = event => {
        let containerRect = element.getBoundingClientRect();
        if (timeoutEvent) clearTimeout(timeoutEvent);
        let posElem = [];
        for (let i = 0; i < nodeListView.length; i++) {
            let id = tabs[i].id;
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(nodeListView[i]);
            posElem.push({ id: id, pos: visiblePageWidth });
        }

        for (let i = 0; i < posElem.length; i++) {
            let item = posElem[i];
            if (item.pos.left + item.pos.width >= containerRect.width) {
                element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
                break;
            }
        }
    };

    const onTouchCancel = event => {
        let containerRect = element.getBoundingClientRect();

        let posElem = [];
        for (let i = 0; i < nodeListView.length; i++) {
            let id = tabs[i].id;
            // Gets the amount of pixels currently visible within the container
            let visiblePageWidth = getVisibleWidth(nodeListView[i]);
            posElem.push({ id: id, pos: visiblePageWidth });
        }

        for (let i = 0; i < posElem.length; i++) {
            let item = posElem[i];
            if (item.pos.left + item.pos.width >= containerRect.width) {
                element.scrollLeft += item.pos.width - (containerRect.width - item.pos.left);
                break;
            }
        }
    };

    const renderTabName = view => {
        let viewNameObj = Utils.convertJSONDataToObject(view.name);
        let viewName = viewNameObj['jp'].text;

        return (
            <div
                onDoubleClick={() =>
                    onDoubleClickViewHelpdeskList(
                        view,
                        isCustomer,
                        viewStructure,
                        isProjectManager,
                        listView,
                        setListView,
                        clickTimeout,
                        setClickTimeout
                    )
                }
                style={{ width: '100%' }}
            >
                {!view.isEditName && (
                    <>
                        <div className="info-item-helpdesk">
                            <OverFlowTooltipWithTabsMui
                                value={viewName}
                                className={`tabName-tlt ${viewSelected?.id === view.id &&
                                    'title-active'}`}
                                onClick={() =>
                                    onChangeViewSelectedHelpdeskList(
                                        view,
                                        viewSelected,
                                        setViewSelected,
                                        viewStructure,
                                        setViewStructure,
                                        setTriggerSearch,
                                        clickTimeout,
                                        setClickTimeout
                                    )
                                }
                            />
                            <SettingView view={view} {...props} />
                        </div>
                    </>
                )}
                {view.isEditName && (
                    <TextField
                        id={view.id}
                        name={view.id}
                        className="input-view-name"
                        defaultValue={viewName}
                        inputProps={{ maxLength: 50 }}
                        onKeyPress={e => onEnterViewName(e, view, props)}
                        onBlur={e => onBlurViewName(e, view, props)}
                        inputRef={inputViewNameRef}
                        autoFocus
                        variant="filled"
                    />
                )}
            </div>
        );
    };

    const renderTabListWrappedInDroppable = () => (
        <DragDropContext
            onDragEnd={e => onDragViewEnd(e, props)}
            onBeforeDragStart={e => onBeforeDragStartHandler(e, props)}
        >
            <Droppable droppableId="droppable" direction="horizontal">
                {(provided, snapshot) => (
                    <div
                        id="container"
                        onWheel={event => onWheel(event)}
                        onTouchEnd={event => onTouchEnd(event)}
                        onTouchCancel={event => onTouchCancel(event)}
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                    >
                        {tabs.map((item, index) => (
                            <Draggable
                                key={item.id}
                                draggableId={item.id + ''}
                                index={index}
                                isDragDisabled={!item?.isMove}
                            >
                                {(provided, snapshot) => (
                                    <div
                                        className={`item item-helpdesk ${viewSelected?.id ===
                                            item.id && 'active'} ${item.isError && 'view-error'} ${
                                            index === tabs.length - 1 ? 'item-helpdesk-last ' : ''
                                        }`}
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                    >
                                        {renderTabName(item)}
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>
        </DragDropContext>
    );

    return <>{renderTabListWrappedInDroppable()}</>;
}
